{
  "title": "Mis tareas",
  "subtitle": "Tareas asignadas a ti en todos los proyectos, y las personales",
  "only_pending": "Solo pendientes",
  "record_meeting": "Grabar reunión",
  "record_meeting_title": "Grabar reunión personal",
  "create_button": "Nueva tarea",
  "create_placeholder": "¿Qué tienes que hacer?",
  "create_submit": "Crear tarea",
  "create_creating": "Creando…",
  "create_cancel": "Cancelar",
  "create_note": "Esta tarea quedará como personal (sin proyecto). Puedes moverla a un proyecto más tarde.",
  "create_error_generic": "No se pudo crear la tarea.",
  "attach_error": "La tarea se creó, pero no se pudieron subir los adjuntos.",
  "rename_task_title": "Editar el nombre",
  "field_name": "Nombre",
  "field_priority": "Prioridad",
  "field_due_date": "Fecha límite",
  "field_team": "Equipo",
  "team_all": "Todos los equipos",
  "team_none": "Sin equipo",
  "field_project": "Proyecto",
  "project_none": "Personal (sin proyecto)",
  "field_link": "Enlace",
  "link_placeholder": "https://… (video, documento, etc.)",
  "field_attachments": "Adjuntos (imagen, video, archivo)",
  "field_description": "Descripción",
  "field_assignee": "Responsable",
  "assignee_me": "Yo",
  "assignees_search": "Buscar miembro…",
  "team_search": "Buscar equipo…",
  "project_search": "Buscar proyecto…",
  "assignees_no_results": "Sin resultados",
  "create_success": "Tarea creada",
  "description_placeholder": "Detalles de la tarea (opcional)",
  "empty_no_assigned": "No tienes tareas asignadas.",
  "empty_create_first": "Crea tu primera tarea",
  "filters": {
    "all": "Todas",
    "open": "Abiertas",
    "completed": "Completadas",
    "label": "Estado",
    "period": "Periodo",
    "period_days": "Últimos {n} días",
    "period_all": "Todo el histórico",
    "project_all": "Todos los proyectos",
    "search_placeholder": "Buscar por nombre…",
    "no_results": "Ninguna tarea coincide con estos filtros."
  },
  "groups": {
    "overdue": "Atrasadas",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "this_week": "Esta semana",
    "upcoming": "Próximas",
    "later": "Más adelante",
    "no_date": "Sin fecha",
    "completed": "Completadas"
  },
  "priority": {
    "urgent": "Urgente",
    "high": "Alta",
    "medium": "Media",
    "low": "Baja"
  },
  "board": {
    "unsorted": "Sin clasificar"
  },
  "empty": {
    "all": "No tienes tareas asignadas. Crea una arriba o espera a que te asignen.",
    "open": "Sin tareas abiertas. ¡Todo al día!",
    "completed": "Aún no completaste ninguna tarea."
  },
  "name_max_reached": "Llegaste al máximo de {n} caracteres para el título.",
  "field_extra_projects": "También en estos tableros",
  "extra_projects_add": "+ Agregar tablero",
  "extra_projects_remove": "Quitar {name}",
  "extra_projects_hint": "La tarea vive en el tablero de arriba y además aparece en los que elijas aquí.",
  "extra_projects_error": "La tarea se creó, pero no se pudo agregar a los otros tableros.",
  "field_requester": "Solicitante",
  "requester_hint": "Quién pidió el trabajo (opcional). Se verá en la tarjeta.",
  "requester_name_placeholder": "Nombre",
  "requester_email_placeholder": "Correo (opcional)"
}
